import script from "./DashboardGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardGrid.vue?vue&type=script&setup=true&lang=js"

import "./DashboardGrid.vue?vue&type=style&index=0&id=7801f24e&lang=scss"

const __exports__ = script;

export default __exports__